import React, {Component} from 'react';
import {withFirebase} from "../Firebase";
import Header from "../Header";
import {withAdmin} from "../Session/context";
import languages from "../../utils/languages";
import { FilePicker } from 'react-file-picker'
import Parser from '../../utils/parser.js'

class PageSeed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projects: [],
        }
    }

    componentDidMount() {
        this.props.firebase.getProjects().then(projects => {
            this.setState({
                projects: projects,
                selected: projects[0].id,
                language: Object.keys(languages)[0]
            })
        });
    }

    changedProject = (event) => {
        this.setState({
            selected: event.target.value
        })
    };

    changedLanguage = (event) => {
        this.setState({
            language: event.target.value
        })
    };

    upload = (file) => {
        const reader = new FileReader();

        // Closure to capture the file information.
        reader.onload = (e) => {
            const fileText = e.target.result;
            const parsed = Parser(fileText);
            this.props.firebase.addSubmission(this.state.selected,this.state.language,parsed);
            alert("Seed submitted! Approve the submission to complete the seed.");
        };

        reader.readAsText(file);
    };

    render() {

        if(!this.state.projects) return null;

        const options = this.state.projects.map(project => (<option key={project.id} value={project.id}>{project.title}</option>));
        const languageOptions = Object.entries(languages).map(([key,value]) => (<option key={key} value={key}>{key} ({value})</option>));

        return (
            <div>
                <Header title={`Upload`} subtitle={`Translations`} />
                <select value={this.state.selected} onChange={this.changedProject}>
                    {options}
                </select>
                <select value={this.state.language} onChange={this.changedLanguage}>
                    {languageOptions}
                </select>
                <FilePicker
                    extensions={['xml']}
                    onChange={this.upload}>
                    <input type="button" value="Choose file to seed" />
                </FilePicker>
            </div>
        );
    }
}

export default withAdmin(withFirebase(PageSeed));